// Copyright (c) 2025 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import { UseMutationResult, useMutation } from '@tanstack/react-query';
import {
  CommercialAgreement,
  CommercialAgreement_Modify_Result,
} from '@daml.js/utility-commercials-v0/lib/Utility/Commercials/V0/Model/CommercialAgreement';
import { UtilityFees } from '@daml.js/utility-commercials-v0/lib/Utility/Commercials/V0/Model/Types/module';
import { ContractId } from '@daml/types';
import { useLedgerApiClient } from '../../../contexts/LedgerApiContext';

export const useModifyCommercialAgreement: () => UseMutationResult<
  CommercialAgreement_Modify_Result,
  string,
  {
    commercialAgreementCid: ContractId<CommercialAgreement>;
    feeReceiver: string;
    utilityFees: UtilityFees;
  }
> = () => {
  const ledgerApi = useLedgerApiClient();

  return useMutation({
    mutationKey: ['modifyCommercialAgreement', ledgerApi],
    mutationFn: async ({ commercialAgreementCid, feeReceiver, utilityFees }) => {
      return ledgerApi.modifyCommercialAgreement(commercialAgreementCid, feeReceiver, utilityFees);
    },
  });
};
